module.exports = __webpack_public_path__ + "static/media/icon_audio_headphones_off.438993d3.svg";